module.exports = require('./helpers/bundle-url').getBundleURL('gR264') + "AdobeExperiencePlatform.6e79ef30.svg";